import script from "./CtaOptionsSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./CtaOptionsSelector.vue?vue&type=script&setup=true&lang=js"

import "./CtaOptionsSelector.vue?vue&type=style&index=0&id=bdd6ab7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bdd6ab7c"]])

export default __exports__